import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';

const Dropdown = ({ label, value, options = [], handleChange, disabled, ...props }) => {

    const selectProps = {
        id: props.id || 'dropdown',
        labelId: props.labelId || 'dropdown-label',
        value: value,
        defaultValue: props.defaultValue,
        onChange: handleChange,
        input: <OutlinedInput label={label} name={props?.name} sx={{ height: props?.height || '40px', minHeight: props?.height || '40px', width: props?.width || "100%", }} />,
        placeholder: props.placeholder || "Search",
        multiple: props.multiple,
        disabled: disabled
    };

    if (props.multiple) {
        selectProps.renderValue = (selected) => selected.join(', ');
    }

    return (
        <FormControl sx={{ width: props?.width || '100%', ...props.styles, height: props?.formHeight, maxWidth: props?.maxWidth || '150px' }} size='small' >
            <InputLabel id={props?.inputLabelId || "dropdown-label"}>{label}</InputLabel>
            < Select {...selectProps} defaultValue={props?.defaultValue || options[0]?.label} >
                {options.map((option) => (
                    <MenuItem key={option?.value} value={option?.value} >
                        {option?.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default Dropdown;